import { isObject, isString } from 'lodash';

export const EMAIL_VERIFIED_BROADCAST_CHANNEL_NAME = 'EMAIL_VERIFIED_BROADCAST_CHANNEL';

export const EMAIL_VERIFIED_BROADCAST_MESSAGE_TYPE = 'EMAIL_VERIFIED';

type EmailVerifiedBroadcastMessage = {
  email: string;
  type: typeof EMAIL_VERIFIED_BROADCAST_MESSAGE_TYPE;
};

type BroadcastCurrentUserEmailVerifiedParams = {
  email: string;
};

const emailVerifiedChannel =
  typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(EMAIL_VERIFIED_BROADCAST_CHANNEL_NAME) : undefined;

export const isEmailVerifiedBroadcastMessage = (data: unknown): data is EmailVerifiedBroadcastMessage => {
  return (
    isObject(data) &&
    'type' in data &&
    data.type === EMAIL_VERIFIED_BROADCAST_MESSAGE_TYPE &&
    'email' in data &&
    isString(data.email)
  );
};

export const subscribeToEmailVerifiedBroadcast = (handleMessage: (event: MessageEvent<unknown>) => void) => {
  if (!emailVerifiedChannel) {
    return;
  }

  emailVerifiedChannel.addEventListener('message', handleMessage);

  return () => {
    emailVerifiedChannel.removeEventListener('message', handleMessage);
  };
};

export const broadcastCurrentUserEmailVerified = ({ email }: BroadcastCurrentUserEmailVerifiedParams) => {
  const message: EmailVerifiedBroadcastMessage = { email, type: EMAIL_VERIFIED_BROADCAST_MESSAGE_TYPE };
  emailVerifiedChannel?.postMessage(message);
};
